<template>
  <div class="InBank">
    <div ref="calculator" id="ib_calculator" />
  </div>
</template>

<script>
import { inbankId } from '../../config'

export default {
  mounted() {
    ((w, d, s, o, f, js, fjs) => {
      // eslint-disable-next-line fp/no-arguments, prefer-rest-params
      w[o] = w[o] || function() { (w[o].q = w[o].q || []).push(arguments) }
      js = d.createElement(s)
      fjs = this.$refs.calculator
      js.id = o; js.src = f; js.async = 1; fjs.parentNode.insertBefore(js, fjs)
    })(window, document, 'script', '_ibCalculator', 'https://skaiciuokles.inbank.lt/js/calculator')

    window._ibCalculator('init', {
      calcKey: inbankId,
      layout: 'ib-003',
      colorScheme: 4,
      element: 'ib_calculator',
      amountTotal: 5000,
      amountAdvance: 0,
      term: 18,
      selectPrice: true,
    })
  },
  beforeDestroy() {
    delete window['loaded-_ibCalculator']
    delete window._ibCalculator
  },
}
</script>

<style lang="scss">
.InBank {
  display: flex;
  justify-content: flex-end;

  #ib_calculator {
    @include md {
      max-width: 90%;
    }
    @include xl {
      max-width: unset;
    }
  }
}
</style>
